import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Layout from "./pages/layout";
import Product from "./pages/product";
import ProductManager from "./pages/admin/products";
import AddProduct from "./pages/admin/addproduct";
import { ThemeProvider } from "./context/ThemeContext";
import EditProduct from "./pages/admin/editproduct";

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<Layout />} >
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<Product />} />
            <Route path="/admin/product-management" element={<ProductManager />} />
            <Route path="/admin/add-new-product" element={<AddProduct />} />
            <Route path="/admin/manage-product/:slug" element={<EditProduct />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
